module.exports = "<footer id=\"footerCntr\">\n  <div class=\"center\">\n\n    <ul>\n      <li><a href=\"#\">Support</a></li>\n    </ul>\n\n    <p>B&S 2018 - All rights reserved</p>\n\n    <div class=\"clear\"></div>\n\n  </div>\n</footer>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/footer/footer.component.html
// module id = ../../../../../src/app/shared/footer/footer.component.html
// module chunks = main